import React, { useState, FormEvent, ReactNode } from 'react';

const STAGING_PASSWORD = 'lashbrook';
const SESSION_KEY = 'staging_authenticated';

interface StagingGateProps {
  children: ReactNode;
}

const StagingGate: React.FC<StagingGateProps> = ({ children }) => {
  const isStaging = process.env.REACT_APP_ENVIRONMENT === 'staging';
  const [authenticated, setAuthenticated] = useState(
    () => !isStaging || sessionStorage.getItem(SESSION_KEY) === 'true'
  );
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  if (authenticated) {
    return <>{children}</>;
  }

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (password === STAGING_PASSWORD) {
      sessionStorage.setItem(SESSION_KEY, 'true');
      setAuthenticated(true);
    } else {
      setError('Incorrect password');
    }
  };

  return (
    <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-bg-white tw-font-sans">
      <div className="tw-w-full tw-max-w-md tw-px-6 tw-text-center">
        <h1 className="tw-text-3xl tw-font-semibold tw-text-[#1e293b] tw-mb-4">
          Staging Access
        </h1>
        <p className="tw-text-sm tw-text-gray-500 tw-mb-1">
          This is Lashbrook's staging site. The pricing and styles shown
        </p>
        <p className="tw-text-sm tw-text-gray-500 tw-mb-6">
          here do not reflect current available pricing and styles.
        </p>
        <p className="tw-text-sm tw-text-gray-600 tw-mb-4">
          Enter the password to continue
        </p>
        <form onSubmit={handleSubmit}>
          <div className="tw-relative tw-mb-4">
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError('');
              }}
              placeholder="Password"
              className="tw-w-full tw-px-4 tw-py-3 tw-border tw-border-gray-300 tw-rounded-md tw-text-sm tw-outline-none focus:tw-border-[#1e293b] tw-pr-16"
              autoFocus
            />
            <div className="tw-absolute tw-right-3 tw-top-1/2 tw--translate-y-1/2 tw-flex tw-items-center tw-gap-1">
              <button
                type="submit"
                className="tw-text-gray-400 hover:tw-text-gray-600 tw-text-lg tw-leading-none"
                title="Submit"
              >
                &gt;
              </button>
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="tw-text-gray-400 hover:tw-text-gray-600"
                title={showPassword ? 'Hide password' : 'Show password'}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  {showPassword ? (
                    <>
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </>
                  ) : (
                    <>
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </>
                  )}
                </svg>
              </button>
            </div>
          </div>
          {error && (
            <p className="tw-text-red-500 tw-text-sm tw-mb-3">{error}</p>
          )}
          <button
            type="submit"
            className="tw-bg-[#1e293b] tw-text-white tw-px-8 tw-py-2.5 tw-rounded-md tw-text-sm tw-font-medium hover:tw-bg-[#334155] tw-transition-colors"
          >
            Enter
          </button>
        </form>
      </div>
    </div>
  );
};

export default StagingGate;
